<template>
  <div>
    支付失败
    <!-- // http://商户自定义地址/notify_url.php?
    trade_no=2014040311001004370000361525&
    out_trade_no=3618810634349901&discount=-5&
    payment_type=1&
    subject=iphone%E6%89%8B%E6%9C%BA&
    body=Hello&price=10.00&
    quantity=1&
    total_fee=10.00&
    trade_status=TRADE_FINISHED&
    refund_status=REFUND_SUCCESS&
    seller_email=chao.chenc1%40alipay.com&
    seller_id=2088002007018916&
    buyer_id=2088002007013600&
    buyer_email=137******70&
    gmt_create=2008-10-22+20%3A49%3A31&
    is_total_fee_adjust=N&
    gmt_payment=2008-10-22+20%3A49%3A50&
    gmt_close=2008-10-22+20%3A49%3A46&
    gmt_refund=2008-10-29+19%3A38%3A25&
    use_coupon=N&
    notify_time=2009-08-12+11%3A08%3A32&
    notify_type=trade_status_sync&
    notify_id=70fec0c2730b27528665af4517c27b95&
    sign_type=DSA&
    sign=_p_w_l_h_j0b_gd_aejia7n_ko4_m%252Fu_w_jd3_nx_s_k_mxus9_hoxg_y_r_lunli_pmma29_t_q%253D%253D&
    extra_common_param=%E4%BD%A0%E5%A5%BD%EF%BC%8C%E8%BF%99%E6%98%AF%E6%B5%8B%E8%AF%95%E5%95%86%E6%88%B7%E7%9A%84%E5%B9%BF%E5%91%8A%E3%80%82 -->
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
